import React from 'react';
import * as LuIcons from 'react-icons/lu';

const suggestedIcons = [
  'LuPalette',
  'LuSmartphone',
  'LuMonitor',
  'LuServer',
  'LuTrendingUp',
  'LuBarChart3',
  'LuCpu',
  'LuClock3',
  'LuShieldCheck',
  'LuHeadphones',
  'LuTarget',
  'LuRocket',
  'LuSparkles',
  'LuUsers',
  'LuGlobe',
  'LuWrench',
];

const IconPickerField = ({ label, value = '', onChange, required = false }) => {
  const iconName = String(value || '').trim();
  const IconComponent = iconName ? LuIcons[iconName] : null;

  return (
    <div>
      <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-gray-400">
        {label}
      </label>
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-primary/10 text-primary dark:border-white/10">
          {IconComponent ? <IconComponent size={20} /> : <LuIcons.LuStar size={20} className="opacity-40" />}
        </div>
        <input
          type="text"
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          placeholder="e.g. LuPalette"
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-primary focus:outline-none dark:border-white/15 dark:bg-[#1a1a1a] dark:text-white"
        />
      </div>
      <p className="mt-1 text-xs text-slate-400 dark:text-gray-500">
        Use Lucide icon names from react-icons/lu (example: LuPalette, LuCpu).
      </p>
      <div className="mt-2 flex flex-wrap gap-2">
        {suggestedIcons.map((icon) => {
          const SuggestedIcon = LuIcons[icon];
          const isActive = iconName === icon;
          return (
            <button
              key={icon}
              type="button"
              onClick={() => onChange(icon)}
              title={icon}
              className={`flex h-9 w-9 items-center justify-center rounded-lg border transition-colors ${
                isActive
                  ? 'border-primary bg-primary/15 text-primary'
                  : 'border-slate-200 text-slate-500 hover:border-primary/40 hover:text-primary dark:border-white/10 dark:text-gray-400'
              }`}
            >
              {SuggestedIcon ? <SuggestedIcon size={16} /> : null}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default IconPickerField;
